import { FunctionComponent } from 'react'
import styled from 'styled-components'

import { ITypographyProps } from '../utils/types'

const Body4Text = styled.p<ITypographyProps>`
  margin: 0;
  font-weight: ${props => props.theme.fonts.weights.medium};
  font-size: ${props => props.theme.fonts.sizes[14]}px;
  text-align: ${props => props.textAlign || 'inherit'};
  color: ${({ theme, color }) => (color ? theme.colors[color] : theme.colors.neutral900)};
  line-height: 19px;
`

const Body4: FunctionComponent<ITypographyProps> = ({ children, tag, ...props }) => (
  <Body4Text
    className="body4"
    {...props}
    as={tag || 'p'}
  >
    {children}
  </Body4Text>
)

export default Body4
